import {BaseContainerModel} from "../../../base-container.model";
import {
  bl_alg_cc_virtual_contact_hdr_RowClass,
  bl_alg_cc_virtual_contact_hdr_RowInterface
} from "../../../../dbschema/bl_alg_cc_virtual_contact_hdr.model";
import {bl_alg_cc_virtual_contact_ext_RowClass} from "../../../../dbschema/bl_alg_cc_virtual_contact_ext.model";
import {bl_alg_cc_endpoint_hdr_RowClass} from "../../../../dbschema/bl_alg_cc_endpoint_hdr.model";

export class VirtualContactContainerModel extends BaseContainerModel {
  bl_alg_cc_virtual_contact_hdr: bl_alg_cc_virtual_contact_hdr_RowInterface = new bl_alg_cc_virtual_contact_hdr_RowClass();
  bl_alg_cc_virtual_contact_exts: bl_alg_cc_virtual_contact_ext_RowClass[] = [];
  bl_alg_cc_endpoint_hdrs: bl_alg_cc_endpoint_hdr_RowClass[] = [];
}
